<template>
<div>
      <notifications position="top center" ></notifications>

  <transition
      enter-class="transition ease-out duration-300 transform"
      enter-active-class="opacity-0"
      enter-to-class="opacity-100"
      leave-class="transition ease-in duration-200 transform"
      leave-active-class="opacity-100"
      leave-to-class="opacity-0"
  >

    <div v-if="this.openModal" class="fixed z-10 inset-0 overflow-y-auto">
      <div class="flex items-start justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <!--
          Background overlay, show/hide based on modal state.

          Entering: "ease-out duration-300"
            From: "opacity-0"
            To: "opacity-100"
          Leaving: "ease-in duration-200"
            From: "opacity-100"
            To: "opacity-0"
        -->
        <div class="fixed inset-0 transition-opacity" aria-hidden="true">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <!--
          Modal panel, show/hide based on modal state.

          Entering: "ease-out duration-300"
            From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            To: "opacity-100 translate-y-0 sm:scale-100"
          Leaving: "ease-in duration-200"
            From: "opacity-100 translate-y-0 sm:scale-100"
            To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        -->
        <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle xl:max-w-lg w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">          <div class="sm:flex sm:items-start">
            <div class="text-center sm:mt-0 sm:text-left w-full">
              <div class="flex justify-between items-center pb-3">
                <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                  Add Contact Representative
                </h3>
                <div class="modal-close cursor-pointer z-50">
                  <svg @click="closeModal" class="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path></svg>
                </div>
              </div>
              <div class="flex flex-col space-y-3">
                <div>
                  <label for="name" class="block text-sm font-medium text-gray-700">Name <sup class="text-red required">*</sup></label>
                  <div class="mt-1">
                    <input type="text" v-model="form.name" name="name" id="name" class="block w-full sm:text-sm">
                  </div>
                </div>
                <div>
                  <label for="title" class="block text-sm font-medium text-gray-700">Title <sup class="text-red required">*</sup></label>
                  <div class="mt-1">
                    <input type="text"  v-model="form.title" name="title" id="title" class="block w-full sm:text-sm">
                  </div>
                </div>
                <div>
                  <label for="email" class="block text-sm font-medium text-gray-700">Email <sup class="text-red required">*</sup></label>
                  <div class="mt-1">
                    <input type="text" v-model="form.email" name="email" id="email" class="block w-full sm:text-sm">
                  </div>
                </div>
                <div>
                  <label for="phone" class="block text-sm font-medium text-gray-700">Phone <sup class="text-red required">*</sup></label>
                  <div class="mt-1">
                    <input type="text" v-model="form.phone" name="phone" id="phone" class="block w-full sm:text-sm">
                  </div>
                </div>
                <div>
                  <label for="calendlyLink" class="block text-sm font-medium text-gray-700">Calendly Link <sup class="text-red required">*</sup></label>
                  <div class="mt-1">
                    <input type="text"  v-model="form.calendly_link" name="calendlyLink" id="calendlyLink" class="block w-full sm:text-sm">
                  </div>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700">State <sup class="text-red required">*</sup></label>
                  <div class="mt-1">
                    <Multiselect
                        v-model="form.selectedStates"
                        :options="states"
                        mode="tags"
                    />
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-4 sm:flex">
            <button @click="createOrUpdate" type="button" class="w-full inline-flex justify-center border border-transparent shadow-sm px-4 py-2 bg-green-500 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:outline-none  focus:ring-green-200 sm:w-auto sm:text-sm">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>

  </transition>
</div>

</template>

<script>
import Multiselect from '@vueform/multiselect'

export default {
  components: {
    Multiselect,
  },
  props: {
    representativeId: null,
    representative: null,
    states: null,
    existingStates: null,
  },
  data() {
    return {
      form: {
        name: null,
        email: null,
        selectedStates: [],
        calendly_link: null,
        id: this.representativeId,
      },
      openModal: false,
    }
  },
  created() {
    this.emitter.on('open-modal', () => {
      this.openModal = true
    });
    this.emitter.on('close-modal', () => {
      this.openModal = false
    });
    if (this.representativeId){
      this.form = this.representative
      this.form.selectedStates = this.existingStates
    }
  },
  methods: {
    createOrUpdate() {
      if (!this.form.name) {
        this.$notify({
          text: 'Name is required',
          type: 'error',
        })
        return
      }
      if (!this.form.email) {
        this.$notify({
          text: 'Email is required',
          type: 'error',
        })
        return
      }
      if (!this.form.title) {
        this.$notify({
          text: 'Title is required',
          type: 'error',
        })
        return
      }
      if (!this.form.phone) {
        this.$notify({
          text: 'Phone is required',
          type: 'error',
        })
        return
      }
      if (this.form.selectedStates.length === 0) {
        this.$notify({
          text: 'State is required',
          type: 'error',
        })
        return
      }
      axios.post('/admin/representatives/create', this.form)
          .then(response => {
            // console.log(response.data)
            this.$notify({
              text: 'Representative event successfully ' + this.action(),
              type: 'success',
            })

            window.location.href = '/admin/representatives'
          })
    },
    action() {
      return this.representativeId ? 'updated' : 'created'
    },
    closeModal() {
      this.openModal = false
    },
  },
}
</script>

<style scoped>

</style>
